<template>
  <div
    id="main-orderlist"
    :data-disabled="disabled">
    <ul
      ref="wrapperItems"
      class="wrapper-items">
      <li
        v-for="(order, index) in orders"
        v-if="order.table_number == table_number"
        :key="index"
        class="item"
      >
        <div class="outer-detail row">
          <div class="col-8 name">
            {{ order.item }}
            <span class="outer-qty">
              <span class="n">x{{ order.quantity }}</span>
              <template v-if="order.uuid === currentUuid">
                <span
                  v-for="i in plusoneCount"
                  :key="i"
                  class="plusone fadeOutUp animated text-success">
                  +1
                </span>
              </template>
            </span>
          </div>
          <div class="col-4 price">{{ getNumber(getTotal([order]).preTax) }}</div>
        </div>
        <template v-if="order.lots">
          <div
            v-for="(lot, lotIndex) in order.lots"
            :key="lotIndex"
            class="col-12 no-padding mt-2"
          >
            <div class="outer-modifier row">
              <div class="col-8 name">
                <strong>
                  {{ lot.lotCode }}
                  <i
                    class="fas fa-pallet"
                    style="font-size: 12px;"/>
                </strong>
              </div>
              <div class="col-4 price">
                {{ lot.unit }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="order.serials">
          <div
            v-for="(serial, serialIndex) in order.serials"
            :key="serialIndex"
            class="col-12 no-padding mt-2"
          >
            <div class="outer-modifier row">
              <div class="col-8 name">
                <strong>
                  {{ serial.serCode }}
                  <i
                    class="fas fa-sd-card"
                    style="font-size: 12px;"/>
                </strong>
              </div>
              <div class="col-4 price">
                {{ serial.unit }}
              </div>
            </div>
            <div
              class="outer-modifier row"
              style="font-size: 11px;">
              <div class="col-8 name">
                {{ serial.serialNumber }}
              </div>
            </div>
          </div>
        </template>
        <div
          v-for="(modifier, index_) in order.modifiers"
          :key="index_"
          class="col-12 no-padding mt-1">
          <div class="outer-modifier row">
            <div class="col-8 name"><strong>{{ modifier.modifier_name }}</strong></div>
          </div>
          <div
            v-for="(option, index__) in modifier.options"
            :key="index__"
            class="outer-modifier row">
            <div class="col-8 name">{{ option.option }}</div>
            <div class="col-4 price">{{ getNumber(option.price) }}</div>
          </div>
        </div>
        <div
          v-if="order.note"
          class="col-12 no-padding mt-1">
          <div class="outer-modifier row">
            <div class="col-8 name"><span>{{ order.note }}</span></div>
          </div>
        </div>
        <div
          v-if="order.discounts.length > 0"
          class="outer-discount row mt-1">
          <div
            v-for="(item, index) in order.discounts"
            v-if="item && item.value_type !== null"
            :key="index"
            class="col-12 text-right"
          >
            <i class="fas fa-tag"/>
            <span v-if="item.value_type == 'percentage'">{{ item.discount_name }} {{ item.value_amount }}%</span>
            <span v-if="item.value_type == 'number'">{{ item.discount_name }} {{ currency }} {{ getNumber(item.value_amount) }}</span>
          </div>
        </div>
        <div class="outer-action">
          <button
            class="btn-edit"
            @click="handleClickEdit(order)">
            <i class="fas fa-pencil-alt"/>
          </button>
          <button
            class="btn-delete"
            @click="handleClickDelete(order)">
            <i class="far fa-trash-alt"/>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import orderListMixin from '@/mixins/pos/orderList'

export default {
  mixins: [orderListMixin],

  methods: {
    handleClickEdit(order) {
      this.onClickEdit(order)
    },
    handleClickDelete(order) {
      this.onClickDelete(order)
      this.$emit('onDeleteOrder', order)
    },
  },
}
</script>

<style scoped>
  ul.wrapper-items {
    height: 100%;
    overflow: hidden;
    overflow-x: hidden;
    margin: 0;
  }
  ul.wrapper-items li.item {
    color: #383D44;
    background: #fff;
    border-bottom: solid 1px #F2F2F2;
    padding: 14px 0 12px 0;
    position: relative;
    cursor: default;
    left: 0;
    transition: left 350ms ease;
  }
  ul.wrapper-items li.item.added {
    left: auto;
    animation: added-item 350ms forwards;
  }
  #main-orderlist[data-disabled="false"] ul.wrapper-items li.item:hover,
  #main-orderlist[data-disabled="false"] ul.wrapper-items li.item.active {
    left: -136px;
  }
  #main-orderlist[data-disabled="true"] ul.wrapper-items li {
    background: #fff;
  }
  @keyframes added-item {
    0% { right: -100px; }
    100% { right: 0; }
  }
  ul.wrapper-items li.item .outer-detail, ul.wrapper-items li.item .outer-modifier, ul.wrapper-items li.item .outer-discount {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
  }
  ul.wrapper-items li.item .outer-detail .name, ul.wrapper-items li.item .outer-modifier .name {
    padding-right: 0;
  }
  ul.wrapper-items li.item .outer-detail .price, ul.wrapper-items li.item .outer-modifier .price {
    text-align: right;
    padding-left: 0;
  }
  ul.wrapper-items li.item .outer-modifier {
    font-weight: normal;
    color: #BBBBBB;
  }
  ul.wrapper-items li.item .outer-discount {
    font-weight: normal;
  }
  ul.wrapper-items li.item .outer-action {
    position: absolute;
    width: 136px;
    height: -webkit-calc(100% + 1px);
  	height:    -moz-calc(100% + 1px);
  	height:         calc(100% + 1px);
    top: 0;
    right: -136px;
    border-bottom: solid 1px #F2F2F2;
  }
  ul.wrapper-items li.item .outer-action button {
    float: left;
    width: 50%;
    height: 100%;
    /* padding: 0 25px 0 25px; */
    padding: 0;
    border: solid 1px #F2F2F2;
    border-top: none;
    border-right: none;
    border-bottom: none;
    background: none;
    font-size: 18px;
    color: #6C7A86;
    background: #fff;
    outline: none;
    cursor: pointer;
    position: relative;
  }
  ul.wrapper-items li.item .outer-action button i {
    position: relative;
    top: 1px;
  }
  .outer-detail span.outer-qty {
    position: relative;
  }
  .outer-detail span.outer-qty span.n {
    position: relative;
    z-index: 1;
  }
  .outer-detail span.outer-qty span.plusone {
    position: absolute;
    top: -8px;
    right: 0;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/OrderList.vue